export const AssetRegistrationTemplateForm = [
  {
    header: {
      header: 'asset_card_no',
      width: 17,
    },
  },
  {
    header: {
      header: 'registration_date',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'start_use_date',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'name',
      width: 40,
    },
  },
  {
    header: {
      header: 'fa_category_code',
      width: 20,
    },
    dataType: 'fa_category_code',
  },
  {
    header: {
      header: 'fa_source_name',
      width: 20,
    },
    dataType: 'fa_source_name',
  },
  {
    header: {
      header: 'uom_code',
      width: 15,
    },
    dataType: 'uom_code',
  },
  {
    header: {
      header: 'base_original_amount',
      width: 20,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'residual',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'residual_value',
      width: 20,
    },
    dataType: 'formula',
    formula: 'H{row}*I{row}/100',
  },
  {
    header: {
      header: 'fa_depreciation_method_name',
      width: 25,
    },
    dataType: 'fa_depreciation_method_name',
  },
  {
    header: {
      header: 'depreciation_start_year',
      width: 20,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'depreciation_start_period',
      width: 20,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'opening_accumulated_depreciation',
      width: 25,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'opening_depreciation_useful_life',
      width: 25,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'depreciation_utilized_useful_life',
      width: 25,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'model_no',
      width: 20,
    },
  },
  {
    header: {
      header: 'ref_no',
      width: 20,
    },
  },
  {
    header: {
      header: 'remark',
      width: 40,
    },
  },
  {
    header: {
      header: 'cost_centre_code',
      width: 20,
    },
    dataType: 'cost_centre_code',
  },
  {
    header: {
      header: 'department_quantity',
      width: 20,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'fa_location_name',
      width: 25,
    },
    dataType: 'fa_location_name',
  },
]
